import React, { Component } from 'react'
import Lightbox from 'react-images'

import Button from './Button'

/**
 * @typedef {typeof defaultProps} Props
 */
const defaultProps = {
  pdf: '',
  images: /** @type {{ src: string}[]} */ ([]),
  open: false,
  close: () => {},
}

/**
 * @typedef {typeof initialState} State
 */
const initialState = {
  current: 0,
}

/** @extends {Component<Props, State>} */
class Manual extends Component {
  static defaultProps = defaultProps
  state = initialState

  DownloadPDF = (
    <Button color="danger" key="download_button" onClick={ () => window.open(this.props.pdf) }>
      Download
    </Button>
  )

  goto = idx => this.setState({ current: idx })
  previous = () => this.setState({ current: this.state.current - 1 })
  next = () => this.setState({ current: this.state.current + 1 })

  click = () => {
    if (this.state.current !== this.props.images.length - 1) {
      this.next()
    }
  }

  close = () => {
    this.setState({ current: 0 })
    this.props.close()
  }

  render = () => {
    return (
      <Lightbox
        enableKeyboardInput
        showThumbnails
        images={ this.props.images }
        isOpen={ this.props.open }
        currentImage={ this.state.current }
        onClickThumbnail={ this.goto }
        onClickPrev={ this.previous }
        onClickNext={ this.next }
        onClickImage={ this.click }
        onClose={ this.close }
        theme={ {
          thumbnail__active: {
            boxShadow: '0 0 0 2px #00D8FF',
          },
        } }
        customControls={ [this.DownloadPDF] }
      />
    )
  }
}

export default Manual



// WEBPACK FOOTER //
// ./src/lib/components/Manual.jsx